import NotificationManager from '../../components/admin/NotificationManager';

// NotificationManager holds the whole notifications UI; this page supplies the
// one page header, so the screen does not show two titles.
const AdminNotificationsPage = () => (
  <div className="admin-notifications-page">
    <div className="admin-page-header">
      <h1 className="admin-page-title">Notifications</h1>
      <p className="admin-page-description">
        Send and schedule notifications to everyone or to chosen users, readers, families, or
        churches, and review what has already gone out
      </p>
    </div>

    <NotificationManager />
  </div>
);

export default AdminNotificationsPage;
